<template>
    <div>
        <div class="row">
            <stats-card v-loading="loader" type="warning" icon="ti-cup" title="Suma szacowanych wpłat 1,5% łącznie"
                        :value="statsValue['1_card']"
                        footerIcon="ti-timer"></stats-card>
            <stats-card v-loading="loader" type="success" icon="ti-wallet"
                        title="Suma wpłat 1,5% z drukowanych deklaracji"
                        :value="statsValue['2_card']"
                        footerIcon="ti-timer"></stats-card>
            <stats-card v-loading="loader" type="danger" icon="ti-info"
                        title="Suma wpłat 1,5% z eDeklaracji"
                        :value="statsValue['3_card']"
                        footerIcon="ti-timer"></stats-card>
            <stats-card v-loading="loader" type="info" icon="ti-email" title="Średnia kwota 1,5% (kwota / wypełnienie)"
                        :value="statsValue['4_card']"
                        footerIcon="ti-timer"></stats-card>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card cardText">
                    <p>Podane w naszych statystykach <strong>wpłaty 1,5% są kwotami szacunkowymi</strong>,
                        wynikającymi z zastosowania odpowiednich współczynników opartych
                        na danych statystycznych z poprzednich lat, które
                        generuje program PIT Format. Brane są pod uwagę kwoty 1,5% wskazane przez podatników w
                        deklaracjach: <strong>zapisanych jako pdf, wydrukowanych oraz wysłanych jako
                            eDeklaracja</strong>.

                        Dane te mają charakter poglądowy, ponieważ nie jest możliwy pełny i dokładny
                        monitoring wpłat 1,5%, np. nastąpiło wydrukowanie czy zapisanie pdf deklaracji w programie, ale
                        nie dostarczono jej finalnie do urzędu skarbowego.<br>
                        Wg naszych analiz wskazane kwoty mogą mieć odchylenie rzędu -/+ 10 %.


                    </p>
                    <div class="text-center">
                        Wybierz zakres dla wykresów
                        <el-date-picker
                                v-model="dateRange"
                                type="daterange"
                                placeholder="Wybierz zakres daty"
                                range-separator=","
                                format="yyyy-MM-dd"
                                v-on:change="dateChange">
                        </el-date-picker>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <bar-chart title="Suma wpłat 1,5%" url="api/legacy/upo" time="200000" localName="all" :dateRange="dateRange"
                       type="sum" :amountValue="true"></bar-chart>
        </div>
        <div class="row">
            <bar-chart title="Suma wpłat 1,5% z drukowanych deklaracji" url="api/legacy/upo" time="200000"
                       :dateRange="dateRange"
                       localName="send"
                       type="sum" type_from="pc_send" :amountValue="true"></bar-chart>
        </div>
        <div class="row">
            <bar-chart title="Suma wpłat 1,5% z eDeklaracji" url="api/legacy/upo" time="200000" :dateRange="dateRange"
                       localName="upo" type="sum" type_from="pc_upo" :amountValue="true"></bar-chart>
        </div>
        <div class="row">
            <bar-chart title="Średnia kwota 1,5% (kwota/wypełnienie) " url="api/legacy/upo-ratio" time="200000"
                       :dateRange="dateRange" type="sum"
                       localName="ratio" :amountValue="true"></bar-chart>
        </div>
    </div>
</template>
<script type="text/babel">
  import StatsCard from 'components/UIComponents/Cards/StatsCard.vue'
  import BarChart from 'components/UIComponents/Charts/BarChart.vue'
  import ApiLocalStorage from 'src/helpers/ApiLocalStorage'

  export default {
    components: {
      StatsCard,
      BarChart
    },
    mounted () {
      this.getCardsData('api/legacy/upo-cards')

      this.dateRange = ApiLocalStorage.getDateRange()
    },
    data () {
      return {
        loader: false,
        statsValue: {
          all: 0,
          send: 0,
          upo: 0,
          ratio: 0
        },
        dateRange: ''
      }
    },
    watch: {
      lic: function () {
        this.getCardsData('api/legacy/upo-cards')
      }
    },
    computed: {
      lic () {
        return this.$store.getters.lic
      }
    },
    methods: {
      getCardsData (apiUrl) {
        this.loader = true
        ApiLocalStorage.requestData('cards' + this.lic, apiUrl, 'post', {
          'lic': this.lic
        }, 900000).then((data) => {
          this.fillData(data)
          setTimeout(() => {
            this.loader = false
          }, 1)
        })
      },
      fillData (data) {
        this.statsValue['1_card'] = data['1_card']
        this.statsValue['2_card'] = data['2_card']
        this.statsValue['3_card'] = data['3_card']
        this.statsValue['4_card'] = data['4_card']
      },
      dateChange (date) {
        ApiLocalStorage.setDateRange(date.split(','))
      }
    }
  }

</script>
<style>
    .cardText {
        padding: 10px;
    }


</style>



// WEBPACK FOOTER //
// Overview.vue?5f3bc966